import { connect } from 'react-redux';

import EventbriteLoginOptions from './EventbriteLoginOptions';

import {
    logInUser as logInUserAction,
    sendResetPasswordEmail as sendResetPasswordEmailAction,
    clearAuthNotification as clearAuthNotificationAction,
    redirectToSignUp as redirectToSignUpAction,
    viewPassword as viewPasswordAction,
} from '../../actions/auth';

import { lookupUser as lookupUserAction } from '../../actions/lookup';

const _mapStateToProps = ({ authentication }) => ({
    socialSSOSettings: authentication.socialSSOSettings,
    showCaptcha: authentication.displayCaptcha,
    recaptcha2PublicKey: authentication.recaptcha2PublicKey,
    recaptcha3PublicKey: authentication.recaptcha3PublicKey,
    disableRecaptcha3: authentication.disableRecaptcha3,
    isAccountExistent: authentication.isAccountExistent,
});

const _mapDispatchToProps = {
    onLogInUser: logInUserAction,
    onLookupUser: lookupUserAction,
    clearAuthNotification: clearAuthNotificationAction,
    handleForgotPassword: sendResetPasswordEmailAction,
    handleSignUpClick: redirectToSignUpAction,
    handleClickViewPassword: viewPasswordAction,
};

export default connect(
    _mapStateToProps,
    _mapDispatchToProps,
)(EventbriteLoginOptions);
